<template>
  <v-layout wrap>
    <v-flex
      v-if="crzLoader"
      xs12
    >
      <v-progress-linear
        height="5"
        color="sz_violet"
        indeterminate
      />
    </v-flex>
    <v-flex
      v-for="(item, index) in consents"
      v-else
      :key="index"
    >
      <v-flex
        v-if="item?.type === 'checkbox'"
        xs12
        mt-3
      >
        <v-checkbox
          v-model="selectedConsents[item?.name]"
          v-validate="setValidationRule(item?.options?.required)"
          type="checkbox"
          class="mt-0"
          :false-value="null"
          :name="item?.name"
          :value="item?.name"
          :data-vv-name="createDataName('consentsRules', item?.name)"
          :error-messages="errors.collect(createDataName('consentsRules', item?.name))"
          :data-vv-as="$t('label.consent')"
          :required="item?.options?.required"
          @change="emmitResults()"
        >
          <template slot="label">
            <p
              class="person-data-consent"
              :class="[{
                'required-block': item?.options?.required,
                'font-weight-bold': BOLD_CONSENTS.includes(item.name) }]"
            >
              <span
                v-if="consentDetails[item?.name].excerpt"
                v-html="item?.options?.attr?.data?.excerpt"
              />
              <span
                v-else
                v-html="item?.options?.label"
              />
              <span v-if="consentDetails[item?.name].excerpt">
                <a
                  v-show="consentDetails[item?.name].show === false"
                  @click.stop="setConsentDetailsShow(item?.name, true)"
                >
                  {{ $t('outside_family.fills_person_data.consent_details_show') }}
                </a>
                <span
                  v-if="consentDetails[item?.name].show"
                  class="d-inline-block mt-1 sz_grey--text"
                >
                  {{ item?.options?.label }}
                  <a @click.stop="setConsentDetailsShow(item?.name, false)">{{
                    $t('outside_family.fills_person_data.consent_details_hide')
                  }}</a>
                </span>
              </span>
            </p>
          </template>
        </v-checkbox>
      </v-flex>
      <v-flex
        v-if="item?.type === 'text'"
        xs12
      >
        <div>
          <p
            class="mb-0"
            v-html="item?.options?.label"
          />
        </div>
      </v-flex>
    </v-flex>
  </v-layout>
</template>

<script>
import has from 'lodash.has';

export default {
    name: 'CRZConsents',
    inject: ['$validator'],
    props: {
        JSONFileName: {
            required: true
        }
    },
    data () {
        return {
            consentDetails: [],
            consentsRules: {
                required: true
            },
            selectedConsents: [],
            consents: [],
            BOLD_CONSENTS: ['154']
        };
    },
    computed: {
        structure () {
            return this.$store.getters['crz/getCrzStructure'];
        },
        crzLoader () {
            return this.$store.getters['crz/getCrzLoader'];
        }
    },
    watch: {
        structure: {
            handler (val) {
                this.setConsents(val);
            },
            deep: true
        },
        JSONFileName: function () {
            this.clearProps();
            this.getData();
        }
    },
    created () {
        this.getData();
    },
    methods: {
        setValidationRule (required) {
            return required ? this.consentsRules : '';
        },
        createDataName (ruleName, itemName) {
            return ruleName + itemName;
        },
        emmitResults () {
            const _res = {};
            this.selectedConsents.forEach((el) => {
                if (el) {
                    _res[el] = true;
                }
            });
            this.$emit('selectedConsents', _res);
        },
        setConsents (val) {
            val.fieldsets.forEach((el) => {
                if (el.name === 'consents') {
                    this.consents = el.fields;
                }
            });

            this.consentDetails = [];
            this.selectedConsents = [];
            this.consents.forEach((el) => {
                if (el?.type === 'checkbox') {
                    let excerpt = false;
                    if (has(el, 'options.attr.data.excerpt')) {
                        excerpt = true;
                    }

                    if (has(el, 'name')) {
                        this.consentDetails[el.name] = {
                            excerpt,
                            show: false
                        };
                    }
                }
                if (has(el, 'name')) {
                    this.selectedConsents[el.name] = null;
                }
            });
        },
        setConsentDetailsShow (name, show) {
            if (has(this.consentDetails, name)) {
                this.consentDetails[name].show = !!show;
            }
        },
        getData () {
            this.$store.commit('crz/setCrzLoader', true);
            this.$store
                .dispatch('crz/getCrzStructure', this.JSONFileName)
                .then(() => {
                    this.setConsents(this.structure);
                })
                .finally(() => {
                    this.$store.commit('crz/setCrzLoader', false);
                });
        },
        clearProps () {
            this.selectedConsents = [];
            this.consents = [];
            this.consentDetails = [];
        }
    }
};
</script>

<style scoped></style>
